import { render, staticRenderFns } from "./MypageDetailsSettingPage.vue?vue&type=template&id=967dc3d8"
import script from "./MypageDetailsSettingPage.vue?vue&type=script&lang=ts"
export * from "./MypageDetailsSettingPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports